import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'

export const useSharedCalendars = () => {
  const { household, user } = useAuth()
  const qc  = useQueryClient()
  const key = ['shared-calendars', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('shared_calendars')
        .select(`
          id,
          calendar_id,
          shared_from_household_id,
          shared_to_household_id,
          calendars(id, name, color),
          from_household:households!shared_calendars_shared_from_household_id_fkey(id, name),
          to_household:households!shared_calendars_shared_to_household_id_fkey(id, name)
        `)
        .or(`shared_from_household_id.eq.${household.id},shared_to_household_id.eq.${household.id}`)
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => qc.invalidateQueries({ queryKey: key })

  // Calendars this household is sharing OUT
  const outgoing = (query.data ?? []).filter((s) => s.shared_from_household_id === household?.id)
  // Calendars this household is receiving
  const incoming = (query.data ?? []).filter((s) => s.shared_to_household_id === household?.id)

  const isSharedOut = (calendarId) => outgoing.some((s) => s.calendar_id === calendarId)

  const toggleShare = async (calendarId, linkedHouseholdId) => {
    if (isSharedOut(calendarId)) {
      const { error } = await supabase
        .from('shared_calendars')
        .delete()
        .eq('calendar_id', calendarId)
        .eq('shared_from_household_id', household.id)
      if (error) throw error
    } else {
      const { error } = await supabase
        .from('shared_calendars')
        .insert({
          calendar_id:              calendarId,
          shared_from_household_id: household.id,
          shared_to_household_id:   linkedHouseholdId,
          created_by:               user.id,
        })
      if (error) throw error
    }
    inv()
    qc.invalidateQueries({ queryKey: ['events', household?.id] })
  }

  return { ...query, outgoing, incoming, isSharedOut, toggleShare }
}
